import { render, staticRenderFns } from "./BookingRecoveryNotice.vue?vue&type=template&id=8194afaa&scoped=true"
import script from "./BookingRecoveryNotice.vue?vue&type=script&lang=js"
export * from "./BookingRecoveryNotice.vue?vue&type=script&lang=js"
import style0 from "./BookingRecoveryNotice.vue?vue&type=style&index=0&id=8194afaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8194afaa",
  null
  
)

export default component.exports